import Vue from 'vue'
import moment from 'moment'
import { sync } from 'vuex-router-sync'
import { inputRules } from '@/plugins/rule'
import App from './App.vue'
import PluginHelper from '@/helpers/PluginHelper'
import utils from '@/plugins/utils'
import { vueFilterRegister } from '@/plugins/filters'
import dialog from '@/plugins/dialog'
import alert from '@/plugins/alert'
import loading from '@/plugins/loading'
import loadingCount from '@/plugins/loadingCount'
import snapshot from '@/plugins/snapshot'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import './registerServiceWorker'
import get from 'lodash-es/get'
moment.locale('vi')

Vue.use(
  PluginHelper.create({
    $utils: utils,
    $rules: inputRules,
    $dialog: dialog,
    $alert: alert,
    $loading: loading,
    $baseUrl: process.env.VUE_APP_API_ENDPOINT,
    $snapshot: snapshot,
    $moment: moment,
    $app: store.state.app,
    $auth: store.state.auth,
    $_get: get,
    $loadingCount: loadingCount
  })
)

vueFilterRegister()

sync(store, router, { moduleName: '$route' })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
